import { store } from '../store.js';

export const pripadLinkMixin = {
  methods: {
    redirectToEditPripad(newId) {
      this.$router.push(`/obchodny-pripad/${newId}`).catch(e => {
        //nist
      });
    },
    redirectToEditNajomca(newId, pridatKontaktnuOsobu) {
      store.commit('setPridatKontaktnuOsobu', pridatKontaktnuOsobu);
      this.$router
        .push(`/obchodny-pripad/${newId}/najomca`)
        .catch(e => {
          //nist
        });
    },
    redirectToSumarNajomca(newId) {
      this.$router
        .push(`/obchodny-pripad/${newId}/sumar/najomca`)
        .catch(e => {
          //nist
        });
    },
    redirectToSumarPredmet(newId) {
      this.$router
        .push(`/obchodny-pripad/${newId}/sumar`)
        .catch(e => {
          //nist
        });
    },
    redirectToUploadDokumentov(newId, cisloPredmetu, poznamka, returnTo) {
      this.openDialog = true;
      this.actionDialogType = 'update';
      if (!poznamka) {
        poznamka = 'poznamka';
        //console.log(poznamka);
      }
      let query = '';
      if (returnTo) {
        query = `?returnTo=${encodeURIComponent(returnTo)}`;
      }
      this.$router
        .push(
          `/dokumentyupload/${newId}/${cisloPredmetu}/${encodeURIComponent(poznamka)}${query}`
        )
        .catch(e => {
          //nist
        });
    },
    redirectToTlacDokumentov(newId) {
      this.$router.push(`/tlacdokumentov?newid=${newId}`);
    },
    redirectToTlacDokumentovPredmet(newId, cisloPredmetu) {
      this.$router.push(
        `/tlacdokumentov?newid=${newId}&cislopredmetu=${cisloPredmetu}`
      );
    },
    redirectToPreberaciProtokol(newId, cisloPredmetu) {
      this.$router.push(
        `/obchodny-pripad/${newId}/predmety/${cisloPredmetu}/preberaci-protokol`
      );
    },
  },
};
